/*
 * Copyright (c) 2021.  Sanish Manandhar
 * All Rights Reserved
 */

export const STATUS_CLEAN_REQUEST = 'STATUS_CLEAN_REQUEST';

export const STATUS_FETCH_REQUEST = 'STATUS_FETCH_REQUEST';
export const STATUS_FETCH_REQUEST_SUCCESS = 'STATUS_FETCH_REQUEST_SUCCESS';
export const STATUS_FETCH_REQUEST_FAILURE = 'STATUS_FETCH_REQUEST_FAILURE';

export const INDEX_CLIENT_LIST_CLEAN_REQUEST = 'INDEX_CLIENT_LIST_FETCH_CLEAN_REQUEST';

export const INDEX_CLIENT_LIST_FETCH_REQUEST = 'INDEX_CLIENT_LIST_FETCH_REQUEST';
export const INDEX_CLIENT_LIST_FETCH_REQUEST_SUCCESS = 'INDEX_CLIENT_LIST_FETCH_REQUEST_SUCCESS';
export const INDEX_CLIENT_LIST_FETCH_REQUEST_FAILURE = 'INDEX_CLIENT_LIST_FETCH_REQUEST_FAILURE';

export const INDEX_STORE_REQUEST = 'INDEX_STORE_REQUEST';
export const INDEX_STORE_REQUEST_SUCCESS = 'INDEX_STORE_REQUEST_SUCCESS';
export const INDEX_STORE_REQUEST_FAILURE = 'INDEX_STORE_REQUEST_FAILURE';

export const STATUS_SUMMARY_FETCH_REQUEST = 'STATUS_SUMMARY_FETCH_REQUEST';
export const STATUS_SUMMARY_FETCH_REQUEST_SUCCESS = 'STATUS_SUMMARY_FETCH_REQUEST_SUCCESS';
export const STATUS_SUMMARY_FETCH_REQUEST_FAILURE = 'STATUS_SUMMARY_FETCH_REQUEST_FAILURE';

export const STATUS_YEAR_FETCH_REQUEST = 'STATUS_YEAR_FETCH_REQUEST';
export const STATUS_YEAR_FETCH_REQUEST_SUCCESS = 'STATUS_YEAR_FETCH_REQUEST_SUCCESS';
export const STATUS_YEAR_FETCH_REQUEST_FAILURE = 'STATUS_YEAR_FETCH_REQUEST_FAILURE';

export const STATUS_OPTIONS_FETCH_REQUEST = 'STATUS_OPTIONS_FETCH_REQUEST';
export const STATUS_OPTIONS_FETCH_REQUEST_SUCCESS = 'STATUS_OPTIONS_FETCH_REQUEST_SUCCESS';
export const STATUS_OPTIONS_FETCH_REQUEST_FAILURE = 'STATUS_OPTIONS_FETCH_REQUEST_FAILURE';

export const EFILE_STATUS_OPTIONS_FETCH_REQUEST = 'EFILE_STATUS_OPTIONS_FETCH_REQUEST';
export const EFILE_STATUS_OPTIONS_FETCH_REQUEST_SUCCESS =
  'EFILE_STATUS_OPTIONS_FETCH_REQUEST_SUCCESS';
export const EFILE_STATUS_OPTIONS_FETCH_REQUEST_FAILURE =
  'EFILE_STATUS_OPTIONS_FETCH_REQUEST_FAILURE';

export const CLIENT_EFILE_STATUS_OPTIONS_FETCH_REQUEST =
  'CLIENT_EFILE_STATUS_OPTIONS_FETCH_REQUEST';
export const CLIENT_EFILE_STATUS_OPTIONS_FETCH_REQUEST_SUCCESS =
  'CLIENT_EFILE_STATUS_OPTIONS_FETCH_REQUEST_SUCCESS';
export const CLIENT_EFILE_STATUS_OPTIONS_FETCH_REQUEST_FAILURE =
  'CLIENT_EFILE_STATUS_OPTIONS_FETCH_REQUEST_FAILURE';

export const EFILE_STATUS_LIST_FETCH_REQUEST = 'EFILE_STATUS_LIST_FETCH_REQUEST';
export const EFILE_STATUS_LIST_FETCH_REQUEST_SUCCESS = 'EFILE_STATUS_LIST_FETCH_REQUEST_SUCCESS';
export const EFILE_STATUS_LIST_FETCH_REQUEST_FAILURE = 'EFILE_STATUS_LIST_FETCH_REQUEST_FAILURE';

export const EFILE_STATUS_UPSERT_REQUEST = 'EFILE_STATUS_UPSERT_REQUEST';
export const EFILE_STATUS_UPSERT_REQUEST_SUCCESS = 'EFILE_STATUS_UPSERT_REQUEST_SUCCESS';
export const EFILE_STATUS_UPSERT_REQUEST_FAILURE = 'EFILE_STATUS_UPSERT_REQUEST_FAILURE';

export const CLIENT_TAX_REPRESENTATIVE_OPTIONS_FETCH_REQUEST =
  'CLIENT_TAX_REPRESENTATIVE_OPTIONS_FETCH_REQUEST';
export const CLIENT_TAX_REPRESENTATIVE_OPTIONS_FETCH_REQUEST_SUCCESS =
  'CLIENT_TAX_REPRESENTATIVE_OPTIONS_FETCH_REQUEST_SUCCESS';
export const CLIENT_TAX_REPRESENTATIVE_OPTIONS_FETCH_REQUEST_FAILURE =
  'CLIENT_TAX_REPRESENTATIVE_OPTIONS_FETCH_REQUEST_FAILURE';

export const EFILE_STATUS_CLEAN_REQUEST = 'EFILE_STATUS_CLEAN_REQUEST';

export const TAX_REVIEW_HISTORY_DETAIL_FETCH_REQUEST = 'TAX_REVIEW_HISTORY_DETAIL_FETCH_REQUEST';
export const TAX_REVIEW_HISTORY_DETAIL_FETCH_REQUEST_SUCCESS =
  'TAX_REVIEW_HISTORY_DETAIL_FETCH_REQUEST_SUCCESS';
export const TAX_REVIEW_HISTORY_DETAIL_FETCH_REQUEST_FAILURE =
  'TAX_REVIEW_HISTORY_DETAIL_FETCH_REQUEST_FAILURE';

export const CLEAN_TAX_REVIEW_HISTORY_DETAIL = 'CLEAN_TAX_REVIEW_HISTORY_DETAIL';
